<div class="n-recuperar-senha-page">
  <div class="n-container">
    <!-- Logo -->
    <div
      class="n-logo-container n-logo-clickable"
      (click)="navegarHome()"
      role="link"
      tabindex="0"
      (keydown.enter)="navegarHome()"
    >
      <img
        class="n-logo"
        src="assets/icons/nomoh_logo.svg"
        alt="Nomoh Logo"
      />
    </div>

    <!-- Card Principal -->
    <div class="n-card">
      <p-stepper [(value)]="active" class="n-stepper">
        <p-step-list>
          <p-step [value]="1">
            <ng-template
              #content
              let-activateCallback="activateCallback"
              let-value="value"
            >
              <span
                class="n-step-icon"
                [ngClass]="{
                  'n-step-active': value <= active,
                  'n-step-inactive': value > active
                }"
              >
                <i class="pi pi-user"></i>
              </span>
            </ng-template>
          </p-step>

          <p-step [value]="2">
            <ng-template
              #content
              let-activateCallback="activateCallback"
              let-value="value"
            >
              <span
                class="n-step-icon"
                [ngClass]="{
                  'n-step-active': value <= active,
                  'n-step-inactive': value > active
                }"
              >
                <i class="pi pi-shield"></i>
              </span>
            </ng-template>
          </p-step>
        </p-step-list>
        <p-step-panels>
          <!-- ETAPA 1: Informar Contato -->
          <p-step-panel [value]="1">
            <ng-template #content let-activateCallback="activateCallback">
              <div class="n-step-content">
                <!-- Cabeçalho da Etapa -->
                <div class="n-step-header">
                  <h2 class="n-title-large">
                    {{ 'PAGINA_RECUPERAR_SENHA.ETAPA_1.TITULO' | translate }}
                  </h2>
                  <p class="n-body-large">
                    {{ 'PAGINA_RECUPERAR_SENHA.ETAPA_1.MENSAGEM' | translate }}
                  </p>
                </div>

                <!-- Toggle Tipo de Recuperação -->
                <div class="n-contact-type-toggle">
                  <div class="n-toggle-container">
                    <div class="n-toggle-label">
                      {{
                        'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.RECUPERAR_POR'
                          | translate
                      }}
                    </div>
                    <div class="n-toggle-options">
                      <!-- <button
                        type="button"
                        class="n-toggle-option"
                        [ngClass]="{
                          'n-toggle-active': tipoRecuperacao() === 'telefone'
                        }"
                        (click)="
                          tipoRecuperacao() !== 'telefone' &&
                            alternarTipoRecuperacao()
                        "
                      >
                        <i class="pi pi-phone"></i>
                        <span>{{ 'GLOBAL.TELEFONE' | translate }}</span>
                      </button> -->
                      <button
                        type="button"
                        class="n-toggle-option"
                        [ngClass]="{
                          'n-toggle-active': true
                        }"
                        (click)="
                          tipoRecuperacao() !== 'email' &&
                            alternarTipoRecuperacao()
                        "
                      >
                        <i class="pi pi-envelope"></i>
                        <span>{{ 'GLOBAL.EMAIL' | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Formulário -->
                <form [formGroup]="formContato" class="n-form-section">
                  <div class="n-field-group">
                    <!-- Campo Telefone -->
                    <div
                      class="n-field n-field-full n-field-animated"
                      [ngClass]="{
                        'n-field-hidden': tipoRecuperacao() !== 'telefone'
                      }"
                      *ngIf="tipoRecuperacao() === 'telefone'"
                    >
                      <lib-form-field
                        label="{{
                          'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.TELEFONE'
                            | translate
                        }}"
                        controlName="telefone"
                        [required]="true"
                      >
                        <lib-phone-input
                          [value]="formContato.get('telefone')?.value ?? ''"
                          (valueChange)="onTelefoneChange($event)"
                        />
                      </lib-form-field>
                    </div>

                    <!-- Campo E-mail -->
                    <div
                      class="n-field n-field-full n-field-animated"
                      [ngClass]="{
                        'n-field-hidden': tipoRecuperacao() !== 'email'
                      }"
                      *ngIf="tipoRecuperacao() === 'email'"
                    >
                      <lib-form-field
                        label="{{
                          'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.EMAIL' | translate
                        }}"
                        controlName="email"
                        [required]="true"
                      >
                        <input
                          pInputText
                          formControlName="email"
                          type="email"
                          [placeholder]="placeholderContato"
                          [autocomplete]="autocompleteContato"
                        />
                      </lib-form-field>
                    </div>
                  </div>
                </form>

                <!-- Ações -->
                <div class="n-form-actions">
                  <!-- <p-button [label]="'PAGINA_RECUPERAR_SENHA.BOTAO.VOLTAR' | translate" styleClass="n-button-sec"
                    (click)="cancelar()" icon="pi pi-arrow-left" /> -->
                  <p-button
                    [label]="'PAGINA_RECUPERAR_SENHA.BOTAO.PROXIMO' | translate"
                    styleClass="n-button-prim"
                    (click)="onSubmitContato()"
                    [disabled]="!campoContatoValido"
                    [loading]="isBotaoSalvar"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                  />
                </div>
              </div>
            </ng-template>
          </p-step-panel>
          <!-- ETAPA 2: Token e Nova Senha -->
          <p-step-panel [value]="2">
            <ng-template pTemplate="content" let-prevCallback="prevCallback">
              <div class="n-step-content">
                <!-- Cabeçalho da Etapa -->
                <div class="n-step-header">
                  <h2 class="n-title-large">
                    {{ 'PAGINA_RECUPERAR_SENHA.ETAPA_2.TITULO' | translate }}
                  </h2>
                  <p class="n-body-large">
                    {{ 'PAGINA_RECUPERAR_SENHA.ETAPA_2.MENSAGEM' | translate }}
                    <span class="n-contact-info">
                      {{
                        contatoInformado
                      }}
                    </span>
                  </p>
                </div>

                <!-- Formulário -->
                <form [formGroup]="formTokenSenhas" class="n-form-section">
                  <div class="n-field-group">
                    <!-- Token de Verificação -->
                    <div class="n-field n-field-full">
                      <lib-form-field
                        label="{{
                          'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CODIGO_VERIFICACAO'
                            | translate
                        }}"
                        controlName="token"
                        [required]="true"
                        [helpText]="textoTipoRecuperacao"
                      >
                        <input
                          pInputText
                          pKeyFilter="num"
                          id="token"
                          formControlName="token"
                          autocomplete="one-time-code"
                          maxlength="6"
                          placeholder="000000"
                          class="w-full n-token-input"
                        />
                      </lib-form-field>
                    </div>

                    <!-- Nova Senha -->
                    <div class="n-field n-field-full">
                      <lib-form-field
                        label="{{
                          'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.SENHA' | translate
                        }}"
                        controlName="senha"
                        [required]="true"
                      >
                        <p-password
                          formControlName="senha"
                          autocomplete="new-password"
                          [toggleMask]="true"
                          [placeholder]="plaholderNovaSenha"
                          [feedback]="true"
                          styleClass="w-full"
                        >
                          <ng-template pTemplate="footer">
                            <div class="n-password-requirements">
                              <p class="n-requirements-title">
                                {{ 'GLOBAL.SENHA_CONTER' | translate }}
                              </p>
                              <ul class="n-requirements-list">
                                <li
                                  class="n-requirement-item"
                                  [ngClass]="{
                                    'n-requirement-valid': hasUpperCase()
                                  }"
                                >
                                  <i
                                    class="pi"
                                    [ngClass]="
                                      hasUpperCase() ? 'pi-check' : 'pi-times'
                                    "
                                  ></i>
                                  {{ 'GLOBAL.UMA_LETRA_MAIUSCULA' | translate }}
                                </li>
                                <li
                                  class="n-requirement-item"
                                  [ngClass]="{
                                    'n-requirement-valid': hasLowerCase()
                                  }"
                                >
                                  <i
                                    class="pi"
                                    [ngClass]="
                                      hasLowerCase() ? 'pi-check' : 'pi-times'
                                    "
                                  ></i>
                                  {{ 'GLOBAL.UMA_LETRA_MINUSCULA' | translate }}
                                </li>
                                <li
                                  class="n-requirement-item"
                                  [ngClass]="{
                                    'n-requirement-valid': hasNumber()
                                  }"
                                >
                                  <i
                                    class="pi"
                                    [ngClass]="
                                      hasNumber() ? 'pi-check' : 'pi-times'
                                    "
                                  ></i>
                                  {{ 'GLOBAL.UM_NUMERO' | translate }}
                                </li>
                                <li
                                  class="n-requirement-item"
                                  [ngClass]="{
                                    'n-requirement-valid': hasSpecialChar()
                                  }"
                                >
                                  <i
                                    class="pi"
                                    [ngClass]="
                                      hasSpecialChar() ? 'pi-check' : 'pi-times'
                                    "
                                  ></i>
                                  {{
                                    'GLOBAL.UM_CARACTERE_ESPECIAL' | translate
                                  }}
                                </li>
                                <li
                                  class="n-requirement-item"
                                  [ngClass]="{
                                    'n-requirement-valid': hasMinLength()
                                  }"
                                >
                                  <i
                                    class="pi"
                                    [ngClass]="
                                      hasMinLength() ? 'pi-check' : 'pi-times'
                                    "
                                  ></i>
                                  {{ 'GLOBAL.MINIMO_CARACTERES' | translate }}
                                </li>
                              </ul>
                            </div>
                          </ng-template>
                        </p-password>
                      </lib-form-field>
                    </div>

                    <!-- Confirmar Senha -->
                    <div class="n-field n-field-full">
                      <lib-form-field
                        label="{{
                          'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CONFIRMAR_SENHA'
                            | translate
                        }}"
                        controlName="confirmarSenha"
                        [required]="true"
                      >
                        <input
                          pInputText
                          id="confirmPassword"
                          formControlName="confirmarSenha"
                          autocomplete="new-password"
                          type="password"
                          [placeholder]="plaholderConfirmarSenha"
                          class="w-full"
                        />
                      </lib-form-field>

                      <!-- Indicador de senhas iguais -->
                      <div
                        class="n-password-match-indicator"
                        *ngIf="formTokenSenhas.get('confirmarSenha')?.value"
                      >
                        <div
                          class="n-match-status"
                          [ngClass]="{
                            'n-match-valid': senhasIguais,
                            'n-match-invalid': !senhasIguais
                          }"
                        >
                          <i
                            class="pi"
                            [ngClass]="senhasIguais ? 'pi-check' : 'pi-times'"
                          ></i>
                          <span>
                            {{
                              senhasIguais ? senhasCoindem : senhasNaoCoindem
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <!-- Ações -->
                <div class="n-form-actions">
                  <p-button
                    [label]="'PAGINA_RECUPERAR_SENHA.BOTAO.VOLTAR' | translate"
                    styleClass="n-button-sec"
                    (click)="voltarEtapa()"
                    icon="pi pi-arrow-left"
                  />
                  <p-button
                    [label]="
                      'PAGINA_RECUPERAR_SENHA.ETAPA_2.ALTERAR_SENHA' | translate
                    "
                    styleClass="n-button-prim"
                    (click)="onSubmitTokenSenha()"
                    [disabled]="!formTokenSenhas.valid"
                    [loading]="isBotaoSalvar"
                    icon="pi pi-check"
                    iconPos="right"
                  />
                </div>
              </div>
            </ng-template>
          </p-step-panel>
        </p-step-panels>
      </p-stepper>
    </div>

    <!-- Link para voltar ao login -->
    <div class="n-login-link">
      <p class="n-body-medium">
        {{ 'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.LEMBROU_SENHA' | translate }}
        <a
          (click)="cancelar()"
          (keyup.enter)="cancelar()"
          (keyup.space)="cancelar()"
          class="n-link"
          style="cursor: pointer"
          tabindex="0"
          role="button"
          >{{ 'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.FAZER_LOGIN' | translate }}</a
        >
      </p>
    </div>
  </div>
</div>
